import React from 'react';
import { colors } from '../../styles/utils';

import HeaderInfoTooltip from '../HeaderInfoTooltip/HeaderInfoTooltip';

export const Dot = ({ color, title, style, className, ...otherProps }) =>
  title ? (
    <HeaderInfoTooltip content={title}>
      <span
        className={['Dot', className].filter((f) => !!f).join(' ')}
        style={{
          backgroundColor: colors[color] || 'transparent',
          ...style
        }}
        {...otherProps}
      />
    </HeaderInfoTooltip>
  ) : (
    <span
      className={['Dot', className].filter((f) => !!f).join(' ')}
      style={{
        backgroundColor: colors[color] || 'transparent',
        ...style
      }}
      {...otherProps}
    />
  );

export default Dot;
